import * as React from 'react';
import * as UserRepository from '../../../Repository/UserRepository';
import CompassOutlined from '@ant-design/icons/CompassOutlined';
import ModalUserFormGeneric from './ModalUserFormGeneric';
import { getRole, UserTypes } from '../../../Repository/UserRepository';
import { roles as ContractRoles } from '../../../Repository/ContractRepository';
import { Button, message, Table, Typography } from 'antd';
import { AdminUserDashBoardRow, impersonate } from "./AdminUsersPage";
import { TeamOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface AdminUsersTableProps {
  list?: AdminUserDashBoardRow[];
  contractId?: number;
  onUpdate: Function;
  mode: 'desktop'|'mobile';
}

export default class AdminUsersTable extends React.Component<AdminUsersTableProps, any>{
  constructor(props: AdminUsersTableProps) {
    super(props);
    this.state = {}
  }

  getActionColumn() {
    return {
      title: 'Actions',
      key: 'actions' + this.constructor.name,
      render: (text: any, record: AdminUserDashBoardRow) => {
        const { onUpdate } = this.props;

        return [
          <div key={'edit-btn-' + record?.id}>
            <ModalUserFormGeneric
              editedObject={record}
              onSave={async (editedObject: any, values: any) => {
                const formData = new FormData();
                Object.entries(values).map(([key, value]) => formData.append(key, String(value)))
                try {
                  const response = await UserRepository.updateUser(record.id, formData);
                  message.success(response.message);
                } catch (error) {
                  console.error(error)
                  return;
                }
                onUpdate && onUpdate(editedObject, values);
              }}
              openButton={<>Edit <CompassOutlined /></>}
              modalTitle={`${record?.first_name} ${record?.last_name} (${record?.id})`}
            />
          </div>,
          <div key={'impersonate-btn-' + record?.id}>
            {record?.email &&
              <Button type='link' onClick={() => impersonate(record.email)}>
                Impersonate<TeamOutlined />
              </Button>
            }
          </div>
        ]
      }
    }
  }

  getMobileColumns() {
    return [
      {
        title: 'User details',
        render: (text: any, record: AdminUserDashBoardRow) => {
          const getRolesList = (record: AdminUserDashBoardRow) => {
            return JSON.parse(record.roles).map((role: string) => {
              return getRole(role)?.label;
            });
          };

          const roles = getRolesList(record);

          return (
            <div key={`${record.id}_ID`}>
              <div key={`${record.id}_ID`}><Text strong>IDs:</Text> {record.id}</div>
              <div key={`${record.id}_NAME`}><Text strong>Name:</Text> {this.getUserName(record)}</div>
              <div key={`${record.id}_ROLES`}>
                <Text strong>Profile:</Text> {roles.join(',')}
              </div>
              <div key={`${record.id}_TREES`}>
                <Text strong>Trees:</Text> {this.renderTrees(record)}
              </div>
            </div>
          );
        }
      },
      this.getActionColumn()
    ]
  }

  getDesktopColumns() {
    return [
      {
        title: 'Name',
        render: (text: any, record: AdminUserDashBoardRow) => {
          return (
            <div>
              <div key={`${record.id}_ID`}><Text strong>ID</Text> {record.id}</div>
              <div key={`${record.id}_NAME`}>{this.getUserName(record)}</div>
            </div>
          );
        }
      },
      {
        title: 'Profile',
        render: (text: string, record: AdminUserDashBoardRow) => {
          const roles = JSON.parse(record.roles).map((role: string) => {
            return <li key={'profile_' + record.id}>{getRole(role)?.label}</li>
          })
          return roles && <div><ul>{roles}</ul></div>;
        }
      },
      {
        title: 'Trees',
        render: (text: string, record: AdminUserDashBoardRow) => {
          return <div>{this.renderTrees(record)}</div>;
        }
      },
      this.getActionColumn()
    ]
  }

  renderTrees(data: AdminUserDashBoardRow) {
    try {
      if (!data.cu_roles) {
        return 0;
      }

      if (JSON.parse(data.cu_roles).indexOf(ContractRoles.TreePlanter.name) > -1) {
        return data.planter_count ? data.planter_count : 0;
      }

      return data.contract_count ? data.contract_count : 0;
    } catch (err) {
      console.error(err);
      return 0;
    }
  }

  getUserName(user: AdminUserDashBoardRow) {
    if (UserTypes.Individual === user.type) {
      return `${user.first_name} ${user.last_name}`
    }
    return user.company;
  }

  render() {
    const { list, mode } = this.props;

    if (!list || list.length === 0) {
      return <h3>No user on this contract</h3>;
    }

    return <Table
      columns={mode === 'mobile' ? this.getMobileColumns() : this.getDesktopColumns()}
      dataSource={list}
      rowKey={'id'}
    />;
  }
}
